import { Avatar, Box, Divider, Grid, InputLabel, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useState } from 'react'
import TextLabel from '../Common/CommonTextLabel'
import { getFileIcon, getValuebyId, SidebarIcon } from '../../Utils/handler';
import ButtonContained from '../Common/ButtonContained';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { useTheme } from '@emotion/react';

import { useConfirm } from 'material-ui-confirm';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import ProfileTable from '../Documents/ProfileDetails';
import { makeStyles } from 'tss-react/mui';
import { DocWithPreview } from '../Common/DocWithPreview';
import CustomDialog from '../Common/CustomDialog';
import DocPreview from '../Common/DocPreview';
import { additionalDocumentTypeList, addressProofTypes, castTypes, idProofTypes } from '../../Utils/enum';




const useStyles = makeStyles()((theme) => {
    return {
        label: {
            letterSpacing: "0.03em",
            marginRight: "2px",
            fontSize: "14px",
            color: theme?.palette?.primary?.main,
            whiteSpace: "wrap",
            marginBottom: "0px",
            lineHeight: '1rem'
        }
    }
})


const VerifyDetails = ({ data, _addUpdateMember, }) => {
    // ---------- Hook -----------
    const theme = useTheme()
    const confirmDialogue = useConfirm();


    // --------------- State -------------
    const [imagePreView, setImagePreView] = useState({ isOpen: false, link: "" });

    return (
        <>
            <Grid container xs={12} spacing={1} >
                <Grid item xs={12} display={"flex"} alignItems={"center"} gap={1} mb={3}>
                    <TextLabel fontSize={{ xs: "10px", sm: "15px", md: "20px" }} title={"NOTICE :"} />
                    <TextLabel color='#222222' fontSize={{ xs: "10px", md: "16px" }} title={"Please Verify Your Details Carefully."} />
                </Grid>

                <Grid container item xs={12} spacing={4} sx={{ height: "100vh", overflow: "auto" }} >

                    <Grid item xs={12} md={5} lg={6} >
                        <ProfileTable personalDetails={data?.personalDetails} generalDetails={data?.generalDetails} nomineeDetails={data?.nomineeDetails} aadharCard={data?.uploadDocuments?.aadharCard} />
                    </Grid>

                    <Grid item xs={12} md={7} lg={6} >
                        <Box flexDirection={"column"}
                            sx={{
                                border: "2px dashed #22222240", backgroundColor: "#F5F5FA", borderRadius: "26px", height: "auto",
                                padding: { xs: "15px", sm: "15px", md: "15px", lg: "15px" },
                            }} >
                            <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Aadhar Card Detail"} marginBottom={1} />

                            {/* Aadhar Card Details.................................................................... */}
                            <Box display={'flex'} gap={1} flexWrap={'wrap'} flexDirection={'column'} >

                                <DocWithPreview
                                    docArray={data?.uploadDocuments?.aadharCard?.frontSide ? data?.uploadDocuments?.aadharCard?.frontSide : []}
                                    docName={"Front Side"}
                                    title={"Front Side"}
                                />
                                <DocWithPreview
                                    docArray={data?.uploadDocuments?.aadharCard?.backSide?.length > 0 ? data?.uploadDocuments?.aadharCard?.backSide : []}
                                    docName={"Back Side"}
                                    title={"Back Side"}
                                />
                            </Box>

                            <Grid container spacing={2} mb={2} mt={1}>
                                <Grid item xs={12} gap={2} >
                                    <Box component="div" display="grid" alignItems={'center'} gridTemplateColumns="2fr 2fr" rowGap={1} columnGap={2}>

                                        <TextLabel color={theme?.palette?.primary?.main} fontSize={{ xs: "14px", sm: "15px" }} title={"Aadhar Number :"} />
                                        <TextLabel fontSize={{ xs: "14px", sm: "16px" }} title={data?.uploadDocuments?.aadharCard?.aadharNumber || "NA"} />

                                        <TextLabel color={theme?.palette?.primary?.main} fontSize={{ xs: "14px", sm: "15px" }} title={"Full Name :"} />
                                        <TextLabel fontSize={{ xs: "14px", sm: "16px" }} title={data?.uploadDocuments?.aadharCard?.fullName || "NA"} />


                                        <TextLabel color={theme?.palette?.primary?.main} fontSize={{ xs: "14px", sm: "15px" }} title={"Date of Birth :"} />
                                        <TextLabel fontSize={{ xs: "14px", sm: "16px" }} title={data?.uploadDocuments?.aadharCard?.dob || "NA"} />

                                        <TextLabel color={theme?.palette?.primary?.main} fontSize={{ xs: "14px", sm: "15px" }} title={"Address :"} />
                                        <TextLabel fontSize={{ xs: "14px", sm: "16px" }} title={data?.uploadDocuments?.aadharCard?.address || "NA"} />

                                    </Box>
                                </Grid>
                            </Grid>


                            {/* ID Proof Details............................................................................. */}

                            <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"ID Proof Detail"} marginTop={1} />

                            <DocWithPreview
                                docArray={data?.uploadDocuments?.idProof?.idProofImage?.length > 0 ? data?.uploadDocuments?.idProof?.idProofImage : []}
                                docName={"ID Proof"}
                                title={"ID Proof"}
                            />

                            <Grid container spacing={2} mt={0} mb={1} >
                                <Grid item xs={12}>
                                    <Box component="div" display="grid" alignItems={'center'} gridTemplateColumns="2fr 2fr" rowGap={1} columnGap={2}>
                                        <TextLabel color={theme?.palette?.primary?.main} fontSize={{ xs: "14px", sm: "15px" }} title={"ID Proof Type :"} />
                                        <TextLabel fontSize={{ xs: "14px", sm: "16px" }} title={data?.uploadDocuments?.idProof?.idProofType ? getValuebyId(data?.uploadDocuments?.idProof?.idProofType, idProofTypes) : "NA"} />
                                    </Box>
                                </Grid>
                            </Grid>


                            {/* LC/DOB Certificate Details............................................................................. */}

                            <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"LC/DOB Certificate Details"} marginTop={1} />

                            <DocWithPreview
                                docArray={data?.uploadDocuments?.lc_dob_certificate?.image?.length > 0 ? data?.uploadDocuments?.lc_dob_certificate?.image : []}
                                docName={"LC/DOB Certificate"}
                                title={"LC/DOB Certificate"}
                            />

                            <Grid container spacing={2} mt={0} mb={1}>
                                <Grid item xs={12}>
                                    <Box component="div" display="grid" alignItems={'center'} gridTemplateColumns="2fr 2fr" rowGap={1} columnGap={2}>
                                        <TextLabel color={theme?.palette?.primary?.main} fontSize={{ xs: "14px", sm: "15px" }} title={"Cast :"} />
                                        <TextLabel fontSize={{ xs: "14px", sm: "16px" }} title={data?.uploadDocuments?.lc_dob_certificate?.cast ? getValuebyId(data?.uploadDocuments?.lc_dob_certificate?.cast, castTypes) : "NA"} />
                                        <TextLabel color={theme?.palette?.primary?.main} fontSize={{ xs: "14px", sm: "15px" }} title={"Birth Place :"} />
                                        <TextLabel fontSize={{ xs: "14px", sm: "16px" }} title={data?.uploadDocuments?.lc_dob_certificate?.birthPlace || "NA"} />
                                    </Box>
                                </Grid>
                            </Grid>

                            {/* Address Proof Details............................................................................ */}
                            <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Address Proof Detail"} marginTop={1} />

                            <DocWithPreview
                                docArray={data?.uploadDocuments?.addressProof?.addressProofFile?.length > 0 ? data?.uploadDocuments?.addressProof?.addressProofFile : []}
                                docName={"Address Proof"}
                                title={"Address Proof"}
                            />

                            <Grid container spacing={2} mt={0}>
                                <Grid item xs={12}>
                                    <Box component="div" display="grid" alignItems={'center'} gridTemplateColumns="2fr 2fr" rowGap={1} columnGap={2}>
                                        <TextLabel color={theme?.palette?.primary?.main} fontSize={{ xs: "14px", sm: "15px" }} title={"Address Proof Type :"} />
                                        <TextLabel fontSize={{ xs: "14px", sm: "16px" }} title={data?.uploadDocuments?.addressProof?.addressProofType ? getValuebyId(data?.uploadDocuments?.addressProof?.addressProofType, addressProofTypes) : "NA"} />
                                    </Box>
                                </Grid>
                            </Grid>

                            {/* Addition Document Details............................................................................ */}
                            <TextLabel fontSize={{ xs: "16px", md: "20px" }} fontWeight={600} color='#3E4094' title={"Addition Document Detail"} marginTop={1} />

                            <DocWithPreview
                                docArray={data?.uploadDocuments?.additionalDocument?.additionalDocumentFile?.length > 0 ? data?.uploadDocuments?.additionalDocument?.additionalDocumentFile : []}
                                docName={"Addition Document"}
                                title={"Addition Document"}
                            />

                            <Grid container spacing={2} mt={0}>
                                <Grid item xs={12}>
                                    <Box component="div" display="grid" alignItems={'center'} gridTemplateColumns="2fr 2fr" rowGap={1} columnGap={2}>
                                        <TextLabel color={theme?.palette?.primary?.main} fontSize={{ xs: "14px", sm: "15px" }} title={"Addition Document Type :"} />
                                        <TextLabel fontSize={{ xs: "14px", sm: "16px" }} title={data?.uploadDocuments?.additionalDocument?.additionalDocumentType ? getValuebyId(data?.uploadDocuments?.additionalDocument?.additionalDocumentType, additionalDocumentTypeList) : "NA"} />
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Grid>

                    <Grid item xs={12} display={"flex"} justifyContent={"flex-end"} >
                        <ButtonContained
                            width={"auto"}
                            text={"Save & continue"}
                            lineHeight={"24.5px"}
                            padding={{ xs: "5px 10px", md: "10px 20px" }}
                            fontSize={{ xs: "12px", md: "14px" }}
                            height={{ xs: "40px", sm: "40px" }}
                            endIcon={<ArrowForwardIcon />}
                            // onClick={() => {
                            //     _addUpdateMember(3)
                            // }}
                            onClick={() =>
                                confirmDialogue({
                                    title: (
                                        <>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                                                <ErrorOutlineOutlinedIcon color='warning' style={{ fontSize: "55px" }} />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: "center", fontSize: "25px" }}>
                                                Are you sure you want to proceed?
                                            </div>
                                        </>
                                    ),
                                    description: (
                                        <Typography
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                textAlign: 'center',
                                            }}
                                        >
                                            The user will be eligible for Suraksha Kavach. If you submit this application with the provided data,
                                            it will be created successfully.
                                        </Typography>
                                    ),
                                    confirmationText: (
                                        <Typography sx={{ fontSize: { xs: '8px', sm: '14px', md: '16px' } }}>
                                            Submit
                                        </Typography>
                                    ),
                                    cancellationText: (
                                        <Typography sx={{ fontSize: { xs: '8px', sm: '14px', md: '16px' } }}>
                                            Cancel
                                        </Typography>
                                    ),
                                    titleProps: {
                                        sx: {
                                            fontSize: '18px',
                                            fontWeight: 500,
                                            color: '#3E4094',
                                            padding: "5px 23px"
                                        }
                                    },
                                })
                                    .then(() => {
                                        _addUpdateMember(3)
                                    })
                                    .catch((err) => { console.log(err) })}
                        />
                    </Grid>

                </Grid>

                {imagePreView?.isOpen &&
                    <CustomDialog
                        isOpen={imagePreView?.isOpen} handleClose={() => setImagePreView({ isOpen: false, link: "" })} title={"View"} padding={'10px'}
                        width={400}
                        action={
                            <DocPreview
                                link={imagePreView?.link}
                                iconName={getFileIcon(imagePreView?.link)}
                                octateFile={true}
                            />
                        }
                        maxWidth={'md'}
                    >
                    </CustomDialog>
                }

            </Grid>
        </>
    )
}

export default VerifyDetails
